import React, { FC } from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoIconOutline from "./icons/InfoIconOutline";

const TooltipInfoIcon: FC = ({ children }) => (
  <Tooltip arrow placement="right" title={<>{children}</>}>
    <span>
      <InfoIconOutline />
    </span>
  </Tooltip>
);

export default TooltipInfoIcon;
